import styled, { css } from "styled-components/native";
import styledRN from "rn-css";
import { Modal as ModalPaper } from "react-native-paper";
import { sm, md, white_smoke } from "../../StyleHelpers";
import { BillingProps, StyledProps, TextProps } from "./models";

export const StyledContainer = styled.View<StyledProps>`
	background-color: rgb(20, 20, 20);

	${(props) =>
		!props.isTermAndService &&
		css`
			display: flex;
			flex-direction: column;
			align-items: center;
			height: 100%;
		`}
`;

export const StyledFormContainer = styled.View<any>`
	display: ${(props) => (props.isShow ? "flex" : "none")};

	${(props) =>
		!props.isNarrow &&
		css`
			width: 100%;
			height: 100%;
			padding: 10rem 20% 3.5rem 20%;
			flex-direction: column;
			justify-content: space-between;
			align-items: flex-start;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			width: 100%;
			height: 100vh;
			padding: 24px 24px;
			padding-top: 90px;
			align-items: flex-start;
			overflow: hidden;
			gap: 16px;
			flex-shrink: 0;
			align-self: stretch
			flex-direction: row;
		`}
`;

export const StyledButtonContainer = styled.View`
	margin-bottom: 20px;
	margin-top: 30px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	z-index: -1;
	width: 100%;
`;

export const StyledNarrowButtonContainer = styled.View`
	display: flex;
	gap: 20px;
`;

export const StyledButton = styled.View`
	width: 49%;
`;

export const StyledModal = styled(ModalPaper)`
	background-color: rgba(0, 0, 0, 0.9);
	height: 100%;
	width: 100%;
	align-items: center;
	position: fixed;
	z-index: 1005;
`;

export const StyledSubmitButton = styled.View`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 10px;
`;

export const StepperContainer = styled.View<any>`
	${(props) =>
		props.isNarrow &&
		css`
			order: 1;
			margin-top: 10px;
			padding-left: 20px;
			width: 138px;
			display: flex;
			justify-content: center;
			align-items: center;
		`}

	${(props) =>
		!props.isNarrow &&
		css`
			margin-top: 3rem;
			width: 100%;
		`}
`;

export const ContentContainer = styled.View<any>`
	${(props) =>
		!props.isNarrow &&
		css`
			width: 100%;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			order: ${props.isNarrow ? 3 : 2};
			margin-top: 5px;
			flex: 1 0 0;
			align-self: stretch;
		`}
`;

export const ButtonContainer = styled.View<any>`
	z-index: -1;
	${(props) =>
		props.isNarrow &&
		css`
			order: ${props.isNarrow ? 2 : 3} 
			margin-top: 10px;
			width: 500px;
		`}

	${(props) =>
		!props.isNarrow &&
		css`
			width: 100%;
		`}
`;

export const StyledFrame = styled.View<any>`
	${(props) =>
		props.isNarrow &&
		css`
			order: 1;
			width: 100%;
			align-items: flex-start;
			gap: 16px;
			flex-shrink: 0;
			flex-direction: row;
		`}

	${(props) =>
		!props.isNarrow &&
		css`
			width: 100%;
			gap: 3rem;
		`}
`;

//Card Details
export const StyledCardContainer = styled.View<any>`
	display: ${(props) => (props.isShow ? "flex" : "none")};
	width: 100%;
	align-items: flex-start;
	align-content: flex-start;
	flex-wrap: wrap;
`;

export const StyledNameContainer = styled.View<any>`
	display: flex;
	width: 100%;
	flex-direction: column;
	gap: ${(props) => (props.isNarrow ? "0.6rem" : "1rem")};
`;

export const StyleHalfInput = styled.View<any>`
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 1rem;
	margin-bottom: ${(props) => (props.isBottom ? "0.4rem" : "0")};
`;

//Billing Details
export const StyledBillingContainer = styled.View<BillingProps>`
	display: ${(props) => (props.show ? "flex" : "none")};
	width: 100%;
	align-items: flex-start;
	align-content: flex-start;
	flex-wrap: wrap;
`;

export const StyledDropdownContainer = styled.View`
	z-index: 1000;
`;

export const StyleTextInput = styled.View`
	width: 100%;
`;

export const StyleTextContainer = styled.View`
	gap: 1rem;
	z-index: 999;
`;

//Purchase Options
export const StyledPurchaseContainer = styled.View<any>`
	display: ${(props) => (props.isShow ? "flex" : "none")};
	flex-direction: row;
	height: 400px;
`;

export const StyledDetailsContainer = styled.View`
	width: 75%;
	overflow-y: scroll;
`;

export const StyledTitleContainer = styled.View`
	display: flex;
	flex-direction: column;
`;

export const StyledPackshotContainer = styled.View`
	width: 25%;
	display: flex;
	justify-content: center;
	align-items: end;
`;

export const StyledDetails = styled.View<any>`
	${(props) =>
		props.isNarrow &&
		css`
			width: 100%;
		`}

	${(props) =>
		!props.isNarrow &&
		css`
			width: 80%;
		`}
`;

export const StyledText = styled.Text<TextProps>`
	color: ${white_smoke};

	${(props) =>
		props.bold &&
		css`
			font-weight: 700;
			font-size: 25px;
		`}

	${(props) =>
		props.fontWeight &&
		css`
			font-weight: ${props.fontWeight};
			font-size: 25px;
		`}

    ${(props) =>
		props.underline &&
		css`
			text-decoration: underline;
			text-decoration-color: ${white_smoke};
		`}
`;

export const StyledTitle = styledRN.Text`
	font-size: 50px;
	line-height: 60px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	@media (min-width:  ${sm}) {
		width: 420px;
	}

	@media (min-width:  ${md}) {
		width: 500px;
	}

`;

export const StyledTextContainer = styled.View`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const StyledMargin = styledRN.View<any>`
	margin-top: 20px;

	@media (min-width: ${(props) => !props.isNarrow && "0"}) {
		width: 70%;
	}
	
	@media (min-width: ${(props) => !props.isNarrow && sm}) {
		width: 80%;
	}

	${(props) =>
		props.isNarrow && {
			width: "100%",
		}}

`;

export const imageNarrow = {
	width: 211,
	height: 317,
	borderRadius: 16,
	borderColor: "#555454",
	borderWidth: 1,
};

export const imageWide = {
	width: 270,
	height: "100%",
	borderRadius: 16,
	borderColor: "#555454",
	borderWidth: 1,
};

export const purchaseTitleNarrow = {
	fontSize: 40,
	lineHeight: 48,
	width: 500,
};

export const purchaseTitleWide = {
	fontSize: 50,
	lineHeight: 60,
	width: 500,
};
